import { apiFetch, ApiBaseUrl } from "./fetch";

export default class ApiTags {
  static getTags(appId) {
    if (!appId) throw Error("App id is missing");
    return apiFetch(`${ApiBaseUrl}apps/${appId}/tags`);
  }

  static createTag(appId, tag) {
    return apiFetch(`${ApiBaseUrl}apps/${appId}/tags`, {
      method: "POST",
      body: tag,
    });
  }

  static updateTag(appId, tag) {
    return apiFetch(`${ApiBaseUrl}apps/${appId}/tags/${tag.id}`, {
      method: "PUT",
      body: tag,
    });
  }

  static deleteTag(appId, tagId) {
    return apiFetch(`${ApiBaseUrl}apps/${appId}/tags/${tagId}`, {
      method: "DELETE",
    });
  }

  static assignTagToPrompt(pathId, tagId) {
    return apiFetch(`${ApiBaseUrl}paths/${pathId}/taggings`, {
      method: "POST",
      body: { tag: { id: tagId } },
    });
  }

  static removeTagFromPrompt(pathId, tagId) {
    return apiFetch(`${ApiBaseUrl}paths/${pathId}/taggings/${tagId}`, {
      method: "DELETE",
    });
  }

  static getPromptTags(pathId) {
    return apiFetch(`${ApiBaseUrl}paths/${pathId}/taggings`);
  }
}
